import { UPDATE_LOGO_REQUEST, UPDATE_LOGO_SUCCESS, UPDATE_LOGO_FAILURE } from '../constants/logoConstants';

export const updateLogoRequest = (logoData) => ({
  type: UPDATE_LOGO_REQUEST,
  payload: logoData,
});

export const updateLogoSuccess = (data) => ({
  type: UPDATE_LOGO_SUCCESS,
  payload: data,
});

export const updateLogoFailure = (error) => ({
  type: UPDATE_LOGO_FAILURE,
  payload: error,
});